export const TDPK = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  TAB_NAME: 'TAB_NAME',
  AC_HISTORY_PLOT: 'AC_HISTORY_PLOT',
};
